/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum TerminationType {
    TERMINATED = 'Terminated',
    RESIGNED = 'Resigned',
    STILL_WORKING = 'Still_Working',
}
